// removed by extract-text-webpack-plugin
module.exports = {"main":"#1A2C5A","secondary_font":"Futura, sans-serif","mobile":"only screen and (max-width: 767px)","contactUs":"contactUs__oXiNw","inputSection":"inputSection__34SBB","label":"label__ZWfYR","inputColumn":"inputColumn__3W8G1","submit":"submit__3a7bb"};


//////////////////
// WEBPACK FOOTER
// ./components/ContactUs/style.css
// module id = g4dw
// module chunks = 0